<template>
  <div class="idback" id="idback">
    <div class="issuer">{{ issuer }}</div>
    <div class="time">{{ valied }}-{{ expire }}</div>
  </div>
</template>

<script>
import domToImage from "dom-to-image";
export default {
  props: {
    //签发机关
    issuer: {
      type: String,
      default: "",
    },
    //有效期开始
    valied: {
      type: [String, Number],
      default: "",
    },
    expire: {
      type: [String, Number],
      default: "",
    },
  },
  methods: {
    getImage() {
      return new Promise((resolve, reject) => {
        domToImage
          .toPng(document.getElementById("idback"))
          .then((dataUrl) => {
            resolve(dataUrl);
          })
          .catch((error) => {
            console.error("oops, something went wrong!", error);
            reject(error);
          });
        // html2Canvas(document.getElementById("idfont")).then((canvas) => {
        //   const jpeg = canvas.toDataURL("image/jpeg", 1.0);
        //   resolve(jpeg);
        // });
      });
    },
  },
};
</script>

<style scoped>
.idback {
  width: 326px;
  height: 207px;
  background-position: center;
  background-repeat: no-repeat;
  /* background: url("~@/assets/image/if_b.bmp"); */
  position: relative;
  color: #333;
  font-weight: 500;
}
.issuer {
  position: absolute;
  left: 135px;
  font-size: 12px;
  bottom: 34px;
}
.time {
  position: absolute;
  left: 135px;
  font-size: 12px;
  bottom: 7px;
}
</style>